const routeNames = {
  general: {
    landing: '/',
    dashboard: '/customer',
    inventory: '/inventory',
    inventory2: '/inventory/:filter',
    inventory3: '/inventory/s/:search',
    viewCar: '/viewCar/:vehicleId',
    apply: '/apply',
    aboutUs: '/aboutus',
    login: '/login',
    signup: '/signup',
    notFound: '/404',
  },
}

export default routeNames
